import {
    Button,
    Form,
    Input,
    InputNumber,
    message,
    Modal,
    Radio,
    Spin,
} from 'antd';
import styles from '../index.module.scss';
import {SimpleSwitch} from 'Features/Fields/SimpleSwitch';
import {useForm, useWatch} from 'antd/es/form/Form';
import {errorMessage, isTrue} from 'Utils/common';
import {SimpleCheckbox} from 'Features/Fields/SimpleCheckbox';
import useRequest from 'Utils/Hooks/useRequest';
import {
    getNormalLoginSetting,
    NormalLoginSettingForm,
    saveNormalLoginSetting,
} from '../service';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import {Auth} from '../../../../Features/Auth';

export function OrdinaryLogin() {
    const [form] = useForm<NormalLoginSettingForm>();

    const status = useWatch('status', form);
    const lengthMin = useWatch('lengthMin', form);

    const [, {loading}] = useRequest(async () => {
        try {
            const data = await getNormalLoginSetting();
            form.setFieldsValue(data);
        } catch (e) {
            Modal.error({content: errorMessage(e)});
        }
    });

    const [onSave, saveStatus] = useRequestFn(
        async (data: NormalLoginSettingForm) => {
            try {
                await saveNormalLoginSetting(data);
                message.success('保存成功!');
            } catch (e) {
                message.error(errorMessage(e));
            }
        },
    );

    return (
        <div className={styles.root}>
            <Spin spinning={loading}>
                <Form
                    form={form}
                    labelCol={{span: 4, style: {paddingRight: 20}}}
                    wrapperCol={{span: 8}}
                    onFinish={onSave}>
                    <Form.Item label="普通登录" name="status">
                        <SimpleSwitch />
                    </Form.Item>

                    <div className={styles.fields} hidden={!isTrue(status)}>
                        <Form.Item
                            label="密码最小长度要求"
                            name="lengthMin"
                            required
                            rules={[
                                {required: true, message: '${label}不能为空'},
                            ]}>
                            <InputNumber min={0} max={20} />
                        </Form.Item>

                        <Form.Item
                            label="密码最大长度要求"
                            name="lengthMax"
                            required
                            rules={[
                                {required: true, message: '${label}不能为空'},
                            ]}>
                            <InputNumber min={lengthMin} max={100} />
                        </Form.Item>

                        <Form.Item
                            label="密码最长使用期限"
                            name="expire"
                            required
                            rules={[
                                {required: true, message: '${label}不能为空'},
                            ]}>
                            <Radio.Group>
                                <Radio value="30">30天</Radio>
                                <Radio value="180">180天</Radio>
                                <Radio value="0">永不过期</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item label="密码组合必须包含(可多选)">
                            <Form.Item name="upperCase" noStyle>
                                <SimpleCheckbox>大写字母</SimpleCheckbox>
                            </Form.Item>

                            <Form.Item name="lowerCase" noStyle>
                                <SimpleCheckbox>小写字母</SimpleCheckbox>
                            </Form.Item>

                            <Form.Item name="numberCase" noStyle>
                                <SimpleCheckbox>数字</SimpleCheckbox>
                            </Form.Item>

                            <Form.Item name="specificSymbol" noStyle>
                                <SimpleCheckbox>特殊符号</SimpleCheckbox>
                            </Form.Item>
                        </Form.Item>

                        <Form.Item
                            label="初始密码"
                            name="defaultPassword"
                            required
                            rules={[
                                {required: true, message: '${label}不能为空'},
                            ]}>
                            <Input maxLength={100} />
                        </Form.Item>
                    </div>

                    <Form.Item label=" " colon={false}>
                        <div className={styles.footer}>
                            <Auth code="SF_GRglhO4j02">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={saveStatus.loading}>
                                    保存
                                </Button>
                            </Auth>
                        </div>
                    </Form.Item>
                </Form>
            </Spin>
        </div>
    );
}
